// extracted by mini-css-extract-plugin
export var divider = "_ec-7";
export var itemsToggle = "_ec-8";
export var mergeModal = "_ec-1";
export var optionCard = "_ec-4";
export var radioGroup = "_ec-6";
export var radioOption = "_ec-0";
export var selected = "_ec-5";
export var shipmentOptions = "_ec-2";
export var tableOptions = "_ec-3";